module.exports = __webpack_public_path__ + "static/media/3x2 L.dec6b60f.kra";